import me from "models/me";
import redirectOnLogin from "helpers/redirectOnLogin";

export default function () {
    return function (nextState, replace, callback) {
        if (me.isSignedIn()) {
            redirectOnLogin({ replace, location: nextState.location });
        }
        callback();
    };
}
